



























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import constants from "../store/constants";
import anime, { AnimeInstance, easings } from "animejs";
import Swiper from 'swiper';
import BackgroundLines from "./BackgroundLines.vue";
import Viewer from "viewerjs";

@Component({
  components: {
    BackgroundLines
  }
})
export default class WindowWithSlider extends Vue {
  @State(state => state.app.contentForSliderInWindow) contentForSliderInWindow!: any[];

  $refs!: {
    root: HTMLElement;
    content: HTMLElement;
    container: HTMLElement;
    mainContainer: HTMLElement;
    thumbsContainer: HTMLElement;
  };

  title: string = "";
  currentContent: any[] = [];
  active = false;
  swiperMain: Swiper | null = null;
  swiperThumbs: Swiper | null = null;
  viewer: Viewer | null = null;

  currentImageNumber = 1;

  get currentImageNumberString() {
    return (this.currentImageNumber < 10) ? `0${this.currentImageNumber}` : this.currentImageNumber;
  }

  close() {
    this.$store.dispatch(constants.windowWithSliderContentChange, []);
  }

  prev() {
    this.swiperMain!.slidePrev();
  }

  next() {
    this.swiperMain!.slideNext();
  }

  mounted() {
    window.addEventListener("keydown", (e: KeyboardEvent) => {
      if (this.active && e.keyCode == 27) {
        this.close();
      }
    });
  }


  @Watch("contentForSliderInWindow")
  contentChange(newValue: any, oldValue: any) {
    if (newValue.length == 0) {
      this.closeWindowHandler();
      return;
    }

    if (oldValue.length == 0 && newValue.length > 0) {
      this.currentContent = this.contentForSliderInWindow;
      this.openWindowHandler();
    }

    this.$nextTick(() => {
      this.swiperThumbs = new Swiper(this.$refs.thumbsContainer, {
        slidesPerView: 8,
        spaceBetween: 20,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          500: {
            slidesPerView: 3
          },
          700: {
            slidesPerView: 4
          },
          850: {
            slidesPerView: 5
          },
          1200: {
            slidesPerView: 6
          }
        }
      });

      this.swiperMain = new Swiper(this.$refs.mainContainer, {
        speed: 1100,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        loop: true,
        initialSlide: 0,
        thumbs: {
          swiper: this.swiperThumbs,
        },
        on: {
          click: () => {
            this.fullScreen(this.swiperMain!.clickedSlide);
          }
        }
      });

      this.currentImageNumber = this.swiperMain!.realIndex + 1;
      this.swiperMain.on("slideChange", () => { this.slideChange(); });
      this.title = this.currentContent[this.swiperMain!.realIndex].title || "";
    });
  }


  slideChange() {
    this.currentImageNumber = this.swiperMain!.realIndex + 1;
    this.title = this.currentContent[this.swiperMain!.realIndex].title || "";
  }


  openWindowHandler() {
    this.currentImageNumber = 1;
    this.active = true;
    setTimeout(() => {
      this.$refs.container.classList.add("showed");

      setTimeout(() => {
        this.$refs.content.style.visibility = "visible";
      }, 800);
    }, 50);
  }


  closeWindowHandler() {
    this.$refs.content.style.visibility = "hidden";
    this.$refs.container.classList.remove("showed");
    setTimeout(() => {
      this.active = false;

      if (this.swiperThumbs !== null) {
        this.swiperThumbs.destroy(true, true);
      }

      if (this.swiperMain !== null) {
        this.swiperMain.destroy(true, true);
      }

      this.currentContent = [];
    }, 850);
  }

  fullScreen(slide: HTMLElement) {
    let image = slide.querySelector("img");
    if (this.viewer !== null) {
      this.viewer.destroy();
    }
    this.viewer = new Viewer(image as Element, {
      title: false,
      toolbar: false,
      navbar: false
    });
    this.viewer.show();
  }
}
